const pad = (n: number) => String(n).padStart(2, "0");

export const dmy = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};
export const dmyhm = (iso: string): string => {
  const d = new Date(iso);
  return `${dmy(iso)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const nowIso = (): string => new Date().toISOString();

export const esc = (s: unknown): string =>
  String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]!));

/** Accepts "example.com" or a full http(s) URL. Empty input is allowed (link without a URL yet). */
export function normalizeUrl(raw: string): { ok: true; url: string } | { ok: false } {
  let u = raw.trim();
  if (!u) return { ok: true, url: "" };
  if (!/^[a-z][a-z0-9+.-]*:/i.test(u)) u = "https://" + u;
  try {
    const p = new URL(u);
    if (!/^https?:$/.test(p.protocol) || !p.hostname.includes(".")) return { ok: false };
    return { ok: true, url: p.href };
  } catch {
    return { ok: false };
  }
}
